/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ChecklistCategoryItem, ChecklistStep } from './index';

export class Checklist {
  name: string;
  groupName: string;
  customerId: number;
  steps: ChecklistStep[];
  categories: ChecklistCategoryItem[];
}
